module.exports = __webpack_public_path__ + "img/Food-Gaborlabel.02758331.jpg";